import { supabase } from './supabase';
import type { Database } from '../types/database.types';

// Loader reutilizable de sedes (S-0 multi-sede). Otras subfases (selector de
// sede en grupos, filtro por sede en agenda/app) reutilizan `loadActiveSedes`
// para poblar sus <select>/<chips> sin duplicar la query. La tabla `sedes` y su
// RLS existen desde 001; SELECT es público, así que no necesita permisos extra.

export type Sede = Pick<
  Database['public']['Tables']['sedes']['Row'],
  'id' | 'name' | 'city' | 'address' | 'active'
>;

const SEDE_COLUMNS = 'id, name, city, address, active';

// Sedes ACTIVAS, ordenadas por nombre. Para selectores donde solo interesan las
// que se pueden asignar hoy.
export async function loadActiveSedes(): Promise<{ sedes: Sede[]; error: string | null }> {
  const { data, error } = await supabase
    .from('sedes')
    .select(SEDE_COLUMNS)
    .eq('active', true)
    .order('name');
  // De aquí salen los <select> con los que se ASIGNA sede a un grupo o a una
  // sesión. Una lista vacía por un fallo de lectura no es un club sin sedes:
  // es un desplegable en el que no se puede elegir, sin decir por qué.
  if (error) return { sedes: [], error: error.message || 'Error desconocido' };
  return { sedes: (data as Sede[]) ?? [], error: null };
}

// TODAS las sedes (activas e inactivas), para la pantalla de gestión.
export async function loadAllSedes(): Promise<{ sedes: Sede[]; error: string | null }> {
  const { data, error } = await supabase
    .from('sedes')
    .select(SEDE_COLUMNS)
    .order('active', { ascending: false })
    .order('name');
  if (error) return { sedes: [], error: error.message || 'Error desconocido' };
  return { sedes: (data as Sede[]) ?? [], error: null };
}
